/* KDG FVN 2026-10-04 · Red de seguridad del bloqueo de scroll de los cajones (menú, carrito, búsqueda…).
   El tema pone html[scroll-lock] al abrir un cajón y lo quita al cerrar el último (global.min.js, DialogComponent).
   Si por algún camino se cierra el cajón sin pasar por ahí, la página queda sin scroll (y antes, apretada en el celular:
   ver kdg-fvn.css, --scrollbar-w). Al cerrarse cualquier <dialog>, si ya no queda ningún cajón modal abierto, se quita. */
(function () {
  var html = document.documentElement;
  function abiertos() {
    try { return document.querySelector('dialog[scroll-lock][open]:modal'); }
    catch (e) { return document.querySelector('dialog[scroll-lock][open]'); }
  }
  document.addEventListener('close', function (e) {
    if (!(e.target instanceof HTMLDialogElement)) return;
    setTimeout(function () {
      if (html.hasAttribute('scroll-lock') && !abiertos()) html.removeAttribute('scroll-lock');
    }, 300);
  }, true);
})();
